import axios from "axios"
import { API_BASE_URL } from "../config"

export const getMedicalRecordList = async (facility_id: string, page: number) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/medical_record_list`, {
        session_code: localStorage.getItem("session_code"),
        facility_id: facility_id,
        page: page
      })

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
